import Konva from 'konva';
import HaspObject from './HaspObject';
import { processIconText } from '../utils/iconFonts';

export default class HaspMsgboxButton extends HaspObject {

    constructor(config) {
        super(config);

        this.haspid = undefined;

        this.textObj = new Konva.Text({
            x: 0,
            y: 0,
            width: config.width,
            height: config.height,
            verticalAlign: 'middle',
            text: processIconText(this.text || ''),
            align: 'center',
            fontSize: config.fontSize || 32,
            fontFamily: 'Roboto Condensed',
            fill: config.textFill || '#eeeeee',
            listening: false,
            draggable: false,
            strokeWidth: 0,
            ellipsis: false,
            wrap: 'none',
            obj: 'text',
        });
        this.add(this.textObj);

        this.draggable(true);

        this.on('text_text', () => {
            this.textObj.text(processIconText(this.text || ''));
            if (this.parentMsgbox) {
                this.parentMsgbox.buttonTextChange(this);
            }
        });

        this.updateButton();
    }

    setSelected(selected) {
        if (selected) {
            this.rect.stroke('#ff0000');
            this.rect.strokeWidth(2);
        } else {
            const itemButtons = this.parentMsgbox?.style('item_buttons');
            this.rect.stroke(itemButtons?.border_color || '#888888');
            this.rect.strokeWidth(itemButtons?.border_width ?? 1);
        }
    }

    updateButton() {
        this.rect.width(this.width());
        this.rect.height(this.height());
        this.textObj.width(this.rect.width());
        this.textObj.height(this.rect.height());
    }
}
